function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6C86B"
    },
    d: "M409.654,1709.607c-27.971,0-55.305-7.542-79.049-21.809 c-22.244-13.367-40.898-32.376-53.945-54.974c-13.047-22.597-20.183-48.257-20.637-74.205c-0.485-27.696,6.651-55.14,20.636-79.363 l614.347-1064.08c13.985-24.223,34.183-44.125,58.411-57.553c22.698-12.581,48.489-19.231,74.582-19.231 c26.094,0,51.883,6.65,74.581,19.23c24.228,13.429,44.426,33.33,58.412,57.553l614.346,1064.08 c13.985,24.222,21.121,51.665,20.638,79.362c-0.454,25.948-7.59,51.608-20.637,74.206c-13.047,22.597-31.701,41.608-53.946,54.976 c-23.743,14.268-51.078,21.809-79.049,21.809H409.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E07F"
    },
    d: "M972.038,466.784L361.87,1523.627c-23.094,40,5.774,90,51.962,90h1220.337 c46.188,0,75.056-50,51.961-90L1075.962,466.784C1052.868,426.784,995.133,426.784,972.038,466.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC636E"
    },
    d: "M1024,1302.971L1024,1302.971c-25.039,0-45.337-20.298-45.337-45.337V780.563 c0-25.039,20.298-45.337,45.337-45.337h0c25.039,0,45.337,20.298,45.337,45.337v477.071 C1069.337,1282.673,1049.039,1302.971,1024,1302.971z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FC636E"
    },
    cx: 1024,
    cy: 1438.027,
    r: 51.143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconWarning);
export default __webpack_public_path__ + "static/media/common_icon_warning.5463328e82280d5b584398a9292feee7.svg";
export { ForwardRef as ReactComponent };